/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Campaigns_LedeInputs */



/**
* | output |
* | --- |
* | "Choose who may enter by role, level, activity and time in the server, reward winners with a role or XP, and see what each giveaway did for activity." |
*
* @param {Products_Campaigns_LedeInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_campaigns_lede = /** @type {((inputs?: Products_Campaigns_LedeInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Campaigns_LedeInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите, кто может участвовать, по роли, уровню, активности и времени на сервере, наградите победителей ролью или XP и посмотрите, что каждый розыгрыш дал активности.")
	return /** @type {LocalizedString} */ ("Choose who may enter by role, level, activity and time in the server, reward winners with a role or XP, and see what each giveaway did for activity.")
});